export default {
  boa: 'Business Owners',
  passport: 'Passport360 Travel',
};
